export default "/images/vendor/flag-icons/flags/4x3/no.svg?b9cc4fcdf51eb234607e1ffa96e3ff63";